import React from 'react';

const TextMessage = props => {
  return <div className="sc-support-message--text">{props.message}</div>;
};

export default TextMessage;
